const MatomoTracker = require('@datapunt/matomo-tracker-js').default;

function createInstance(params) {
    return new MatomoTracker(params);
}

module.exports = createInstance;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-react/es/instance.js
// module id = 767
// module chunks = 0